/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface ITeacher{
    id:number,
    name:string,
    sex:number,
    phone:string,
    picture:string,
    birthday:Date,
    remark:string,
    enable:boolean,
    storeIds:number[],
}

export const listTeachers = () =>
    getCommon({
        url: `${config.SERVICE_URL}/teacher/list_all`,
    });

export const createTeacher = (data:ITeacher) =>
    postCommon({
        url: `${config.SERVICE_URL}/teacher/create`,
        data
    });

export const updateTeacher = (data:ITeacher) =>
    postCommon({
        url: `${config.SERVICE_URL}/teacher/update`,
        data
    });

export const deleteTeacher = (id:number) =>
    postCommon({
        url: `${config.SERVICE_URL}/teacher/delete?id=${id}`
    });

export const enableTeacher = (id:number, enable:boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/teacher/enable?id=${id}&&enable=${enable}`
    });

export const pageTeachers = (pageNum:number,pageSize:number,storeIds:any,keyword:string) =>
    getCommon({
        url: `${config.SERVICE_URL}/teacher/page?pageNum=${pageNum}&&storeIds=${storeIds}&&pageSize=${pageSize}&&keyword=`+encodeURI(keyword),
    });